import {Roles} from 'app/Constants';
import IntegrityRoleGrid from 'components/UserRole';
import {Column, Lookup} from 'devextreme-react/data-grid';
import {i18n2} from 'features/i18n/i18n';
import React from 'react';
import {lookupType} from '../component/ChoiceGrid';
import {useIntegrityChoice} from '../hooks/index';

const IntegrityChoiceGrid = (props) => {
  const loadChoices = useIntegrityChoice(props.data.key);
  return (
    <>
      <IntegrityRoleGrid
        allowEdit={[Roles.AdminQA, Roles.AdminHSE, Roles.AdminITPS]}
        dataSource={loadChoices}
        id={['revision']}
        height={'30vh'}
        allowIntegrity={false}
        allowActions={false}
      >
        <Column caption={i18n2._('#Pregunta')} dataField="iD_Choice" />
        <Column caption={i18n2._('Titulo')} dataField="question" />
        <Column caption={i18n2._('Tipo')} dataField="type">
          <Lookup dataSource={lookupType} valueExpr="id" displayExpr="name" />
        </Column>
        <Column caption={i18n2._('Revision')} dataField="revision" />
        <Column caption={i18n2._('Motivo')} dataField="reason" />
        <Column
          caption={i18n2._('Fecha de actualizacion')}
          hidingPriority={3}
          dataField="updateDate"
          defaultSortOrder={'desc'}
        />
        <Column
          caption={i18n2._('Actualizado por')}
          hidingPriority={4}
          dataField="updatedBy"
        />
        <Column
          caption={i18n2._('Eliminado')}
          dataField="deleted"
          width={100}
        />
      </IntegrityRoleGrid>
    </>
  );
};

export default IntegrityChoiceGrid;
